const {groupGaps} = require('./timesheetReviewGaps');
const defaults = () => ({search: '', object: '', author: '', category: '', status: '', issue: '', onlyIssues: false, sortKey: '', sortDirection: 'asc'});

function filterGroups(grid, filters, sourceIndex) {
    const f = Object.assign(defaults(), filters);
    const sources = sourceIndex || new Map((grid.sources || []).map(source => [source.timesheet_id, source]));
    const search = String(f.search).trim().toLocaleLowerCase('ru');
    return (grid.groups || []).filter(group => {
        if (search && !group.name.toLocaleLowerCase('ru').includes(search)) return false;
        const hasGap = (f.issue === 'missing_marks' || f.onlyIssues && !group.issues.length) && groupGaps(grid, group, sources).size > 0;
        if (f.onlyIssues && !group.issues.length && !hasGap) return false;
        if (f.issue && !(f.issue === 'missing_marks' ? hasGap : group.issues.some(issue => issue.type === f.issue))) return false;
        // Select groups, never remove their contributing rows or recalculate partial totals.
        return group.rows.some(row => {
            const source = sources.get(row.source_id) || {};
            return (!f.object || String(source.building_id) === f.object)
                && (!f.author || String(source.author_id) === f.author)
                && (!f.status || source.status === f.status)
                && (!f.category || row.category === f.category);
        });
    });
}

function viewState(value) {
    const source = value || {};
    const filters = defaults();
    Object.keys(filters).forEach(key => {
        filters[key] = key === 'onlyIssues' ? source.filters && source.filters[key] === true
            : String(source.filters && source.filters[key] || '').slice(0, 200);
    });
    return {view: ['readiness', 'days'].includes(source.view) ? source.view : 'grid',
        kind: 'official', includeDrafts: source.includeDrafts === true, filters,
        scrollTop: Math.max(0, Number(source.scrollTop) || 0), scrollLeft: Math.max(0, Number(source.scrollLeft) || 0),
        pageScrollTop: Math.max(0, Number(source.pageScrollTop) || 0)};
}

function ownsScroll(route) {
    const query = route && route.query || {};
    return Boolean(route && (route.name === 'timesheets' && query.mode === 'review'
        || route.name === 'timesheet' && query.from === 'review' && /^[1-9]\d*$/.test(String(query.review_line || ''))));
}

// Freeze BEFORE assigning to Vue data. This is a read-only server snapshot, not
// an editable sheet. In particular, do not observe every employee/day property.
function snapshot(grid) { return Object.freeze(grid); }
function comparable(grid) { return JSON.stringify(grid && {...grid, generated_at: null}); }

module.exports = {defaults, filterGroups, viewState, ownsScroll, snapshot, comparable};
